import { Box } from '@mui/material';
import defaultPartnerImage from 'assets/img/partners/default-partner-image.png';
import {
  OpacityContainer,
  PartnerImage,
  Title,
} from 'FeatureModules/Partner/Components/PartnersTable/PartnersTableBody/PartnersTableBody.styles';
import { ThemeTypography } from 'DesignSystem';
import React from 'react';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import {
  getCompanyStatusColor,
  getReadableCompanyStatus,
} from 'FeatureModules/Partner/utils/partner.utils';

interface IProps {
  partner: IBasePartnerCompany;
}

const PartnerSummary: React.FC<IProps> = ({ partner }) => {
  return (
    <OpacityContainer display="flex" is-transparent="false">
      <PartnerImage
        alt={`Logo of ${partner.name}`}
        src={partner.logo?.url || defaultPartnerImage}
      />
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Title>{partner.name}</Title>

        <ThemeTypography variant="ITEM_SUBTITLE" color={getCompanyStatusColor(partner.status)}>
          {getReadableCompanyStatus(partner.status)}
        </ThemeTypography>
      </Box>
    </OpacityContainer>
  );
};

export default PartnerSummary;
